module.exports = __webpack_public_path__ + "img/logo_nestle.21f348af.png";